import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Banknote } from 'lucide-react';
import { trackAdEvent } from '@/lib/adPixels';

export default function OrderPlaced() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get('orderId') || '';
  const total = Number(params.get('total') || 0);

  useEffect(() => {
    if (orderId) trackAdEvent('Purchase', { value: total }, orderId);
  }, [orderId, total]);

  return (
    <div className="container mx-auto px-4 py-10 max-w-lg">
      <Card>
        <CardContent className="pt-8 pb-6 text-center space-y-4">
          <CheckCircle2 className="h-14 w-14 text-primary mx-auto" />
          <h1 className="text-2xl font-bold">Order placed!</h1>
          {orderId && (
            <p className="text-sm text-muted-foreground">
              Order #{orderId.slice(0, 8).toUpperCase()}
            </p>
          )}
          <div className="flex items-start gap-3 text-left p-4 rounded-lg bg-muted">
            <Banknote className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
            <p className="text-sm">
              You chose <strong>Pay on Delivery</strong>.
              {total > 0 && <> Please have <strong>₦{total.toLocaleString()}</strong> ready</>} — pay the
              rider or seller when your order arrives. Only pay after you have received your items.
            </p>
          </div>
          <div className="flex flex-col gap-2 pt-2">
            <Button onClick={() => navigate(`/track-order${orderId ? `?orderId=${orderId}` : ''}`)}>
              Track my order
            </Button>
            <Button variant="outline" onClick={() => navigate('/products')}>
              Continue shopping
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
